require('../../util/money-parser');

$(() => {
  const $form = $('#donation-form');
  const $snackBar = $('[data-js-snack-bar]');
  let fundraisingOrganizations = [];
  let registrants = [];
  let teams = [];
  let subEvents = [];
  let mandatoryDonationSettings = [];
  let globalMandatoryDonationSettings = null;

  const selectors = {
    container: '.js-registrant-donation',
    totalDonationAmount: '.js-total-donation-amount',
    addDonation: '.js-donation-add',
    applyDonation: '.js-donation-apply',
    editDonation: '.js-donation-edit',
    removeDonation: '.js-donation-remove',
    donationAmountOptionsContainer: '.js-donation-amount-options',
    copyDonationInput: '.js-donation-copy',
    donationAmountInput: ':input[name*="[amount]"]',
    customDonationAmountInput: ':input[name*="[custom_amount]"]',
    isFeeAppendedInput: ':input[name*="[is_fee_appended]"]',
    fundraisingOrganizationInput: ':input[name*="[fundraising_organization]"]',
    fundraisingOrganizationInputEmptyValue: '[data-js-chosen-organization-empty-value]',
    donationTypeInput: ':input[name*="[type]"]',
    donationTaxReceiptInput: ':input[name*="[is_tax_receipt_requested]"]',
    isAnonymousInput: ':input[name*="[is_anonymous]"]',
    isAmountAnonymousInput: ':input[name*="[is_amount_anonymous]"]',
    donorTypeInput: ':input[name*="[donor_type]"]',
    donationDonorDisplayNameInput: ':input[name*="[donor_name]"]',
    donationDonorMessageInput: ':input[name*="[donor_message]"]',
    addDonationContainer: '.js-add-donation-section',
    donationContainer: '.js-donation-section',
    collapsedDonationContainer: '.js-collapsed-donation-container',
    collapsedDonationAmount: '.js-collapsed-donation-amount',
    collapsedDonationFundraisingOrganizationName: '.js-collapsed-fundraising-organization-name',
    customDonationAmountContainer: '.js-custom-donation-amount',
    isFeeAppendedContainer: '.js-is-fee-appended-container ',
    donationAmountWithFees: '.js-donation-amount-with-fees',
    donationAmountWithFeesFormatted: '.js-donation-amount-with-fees-formatted',
    fundraisingOrganizationContainer: '.js-donation-fundraising-organization-container',
    requiredLabelContainer: '[data-required-label-container]',
    fundraisingOrganizationDetails: '.js-donation-fundraising-organization-details',
    singleFundraisingOrganizationHeader: '.js-single-fundraising-organization-header',
    fundraisingOrganizationDescription: '.js-fundraising-organization-description',
    fundraisingOrganizationLogo: '.js-fundraising-organization-logo',
    donationSettingsContainer: '.js-donation-settings',
    fundraisingOrganizationQuestions: '.js-donation-fundraising-organization-questions',
    donationTaxReceiptContainer: '.js-donation-tax-receipt',
    donationMinimumTaxReceiptAmountContainer: '.js-minimum-tax-amount-container',
    donationMinimumTaxReceiptAmount: '.js-minimum-tax-amount',
    donationTaxReceiptOptIn: '.js-tax-receipt-opt-in-text',
    donationTaxReceiptForce: '.js-tax-receipt-force-text',
    donationTaxReceiptNotice: '.js-tax-receipt-notice',
    donationDonorDisplayNameContainer: '.js-donation-donor-display-name',
    donationDonorDisplayNameAliased: '.js-donor-display-name-aliased',
    donationDonorDisplayNameCompany: '.js-donor-display-name-company',
    mandatoryDonationText: '[data-js-mandatory-donation-text]',
    globalMandatoryDonationText: '[data-js-global-mandatory-donation-text]',
  };

  /**
   * Transform json data into array
   * @param json
   * @returns {*[]}
   */
  function mapJSON(json) {
    return Object.keys(json).map((key) => json[key]);
  }

  /**
   * Get the fundraising organization
   *
   * @param registrantIndex
   * @param fundraisingOrganizationId
   * @returns {T}
   */
  function getFundraisingOrganization(registrantIndex, fundraisingOrganizationId) {
    return fundraisingOrganizations[registrantIndex - 1]
      .find((fundraisingOrganization) => fundraisingOrganization.id === parseInt(fundraisingOrganizationId, 10));
  }

  /**
   * Does the form only have a single registrant donation possible?
   * @returns {boolean}
   */
  function hasSingleRegistrant() {
    return $form.find(selectors.container).length === 1;
  }

  /**
   * Get the team for the registrant
   * @param registrantIndex
   * @returns {*}
   */
  function getRegistrantTeam(registrantIndex) {
    const currentRegistrant = registrants.find((registrant) => registrant.index === registrantIndex);

    if (!currentRegistrant || !currentRegistrant.teamId) {
      return null;
    }

    const registrantTeam = teams[registrantIndex - 1].find((team) => {
      if (team.isProvisional) {
        return `temp-${team.id}` === currentRegistrant.teamId;
      }

      return team.id === currentRegistrant.teamId;
    });

    return registrantTeam || null;
  }

  /**
   * Get the sub-event for the registrant
   * @param registrantIndex
   */
  function getRegistrantSubEvent(registrantIndex) {
    const currentRegistrant = registrants.find((registrant) => registrant.index === registrantIndex);

    if (!currentRegistrant || !currentRegistrant.subEvent) {
      return null;
    }

    const registrantSubEvent = subEvents[registrantIndex - 1]
      .find((subEvent) => subEvent.id === currentRegistrant.subEvent);

    return registrantSubEvent || null;
  }

  /**
   * We want to pre-expand the form when there is only a single registrant
   */
  function possiblyExpandFormWhenOneRegistrant() {
    if (hasSingleRegistrant() && $form.find(selectors.addDonation).is(':visible')) {
      $form.find(selectors.addDonation).trigger('click');
    }
  }

  /**
   * Get the registrant's selected fundraising organization
   *
   * @param registrantIndex
   * @returns {*}
   */
  function getSelectedFundraisingOrganization(registrantIndex) {
    const $donationContainer = $form
      .find(`${selectors.donationContainer}[data-registrant-index="${registrantIndex}"]`);
    const $fundraisingOrganizationInput = $donationContainer.find(selectors.fundraisingOrganizationInput);
    return getFundraisingOrganization(registrantIndex, $fundraisingOrganizationInput.val());
  }

  /**
   * A team may only have a subset of the organizations available to it
   * @param organizations
   * @param team
   */
  function filterOrganizationsForTeam(organizations, team) {
    if (!team) {
      return organizations;
    }

    return organizations.filter((organization) => team.fundraisingOrganizations.some(
      (teamOrganizationUuid) => teamOrganizationUuid === organization.uuid,
    ));
  }

  /**
   * Filter a list of organizations by the ones that the sub-event can donate to
   * @param organizations
   * @param subEvent
   */
  function filterOrganizationsForSubEvent(organizations, subEvent) {
    if (!subEvent?.fundraisingOrganizations?.length) {
      return organizations;
    }

    return organizations.filter((organization) => subEvent.fundraisingOrganizations.some(
      (subEventOrganizationId) => subEventOrganizationId === organization.id,
    ));
  }

  /**
   * Filter the fundraising organizations for a given registrant
   *
   * @param registrantIndex
   */
  function filterOrganizationForRegistrant(registrantIndex) {
    let organizations = filterOrganizationsForTeam(
      fundraisingOrganizations[registrantIndex - 1],
      getRegistrantTeam(registrantIndex),
    );
    organizations = filterOrganizationsForSubEvent(organizations, getRegistrantSubEvent(registrantIndex));
    return organizations;
  }

  /**
   * Get the donation amount for a registrant
   *
   * @param registrantIndex
   * @param getOriginalAmount Get the amount directly from user input instead of calculated amount from fees
   * @returns {number}
   */
  function getDonationAmount(registrantIndex, getOriginalAmount = false) {
    const $donationContainer = $form
      .find(`${selectors.donationContainer}[data-registrant-index="${registrantIndex}"]`);
    const $donationAmount = $donationContainer.find(selectors.donationAmountInput).filter(':checked');
    const $customAmount = $donationContainer.find(selectors.customDonationAmountInput);
    const donationAmountWithFees = window.parseMoney(
      $donationContainer.find(selectors.donationAmountWithFees).val(),
      window.RR.locale,
    );

    if (!$donationAmount.length) {
      return 0.00;
    }

    const amount = $donationAmount.val() === 'other'
      ? window.parseMoney($customAmount.val() || 0.00, window.RR.locale)
      : window.parseMoney($donationAmount.val(), window.RR.locale);

    if (getOriginalAmount) {
      return amount;
    }

    // Use the amount with fees if it is available and at least the amount determined above
    return !Number.isNaN(donationAmountWithFees) && donationAmountWithFees >= amount
      ? donationAmountWithFees
      : amount;
  }

  /**
   * Get the total of the donations made by each registrant
   *
   * @returns {number}
   */
  function getTotalDonationAmount() {
    return $form
      .find(selectors.donationContainer)
      .get()
      .reduce(
        (accumulator, element) => accumulator + getDonationAmount($(element).data('registrant-index')),
        0,
      );
  }

  /**
   * Set applicable mandatory donation settings for sub event
   *
   * @param registrantIndex
   *
   * @return Object|null
   */
  function getMandatoryDonationSettings(registrantIndex) {
    const subEvent = getRegistrantSubEvent(registrantIndex);
    const mandatoryDonationSettingsForEvent = mandatoryDonationSettings[registrantIndex - 1];
    let donationSettings = mandatoryDonationSettingsForEvent
      .find((x) => x.ruleTypeIsSubEvent === true
        && x.includedSubEventIds.includes(parseInt(subEvent?.id, 10)));

    if (!donationSettings) {
      donationSettings = mandatoryDonationSettingsForEvent
        .find((x) => x.ruleTypeIsGlobal === true && x.minimumRequiredOn === 'PER_REGISTRANT');
    }

    return donationSettings;
  }

  /**
   * Update the display of the donation amount in the fees well
   *
   * @param event
   */
  function updateDonationAmountWithFees(event) {
    const $this = $(event.currentTarget);
    const $donationContainer = $this.closest(selectors.donationContainer);
    const $amountWithFees = $donationContainer.find(selectors.donationAmountWithFees);
    const $amountWithFeesFormatted = $donationContainer.find(selectors.donationAmountWithFeesFormatted);
    const $isFeeAppended = $donationContainer.find(selectors.isFeeAppendedInput);
    const registrantIndex = $donationContainer.data('registrant-index');
    const amount = getDonationAmount(registrantIndex, true);
    const $fundraisingOrganizationInput = $donationContainer.find(selectors.fundraisingOrganizationInput);

    // If it's $0 or the donor has not chosen to pay the fees, let's just update without a request
    if (amount <= 0 || !$isFeeAppended.is(':checked')) {
      $amountWithFees.val(amount).trigger('change');
      $amountWithFeesFormatted.html(window.RR.numberFormatter.format(amount));
      return;
    }

    $amountWithFeesFormatted.html('<span class="fa fa-spinner fa-pulse"></span>');
    $.ajax(
      {
        url: window.RR.calculateDonationAmountWithFeesUrl,
        type: 'post',
        data: {
          amount,
          fundraising_organization_id: $fundraisingOrganizationInput.val(),
        },
        dataType: 'json',
      },
    )
      .done((response) => {
        $amountWithFees.val(response.data.amountWithFeesFloat).trigger('change');
        $amountWithFeesFormatted.html(window.RR.numberFormatter.format(response.data.amountWithFeesFloat));
      })
      .fail(() => {
        $amountWithFees.val(amount).trigger('change');
        $amountWithFeesFormatted.html(window.RR.numberFormatter.format(amount));
      });
  }

  /**
   * Update the donation total display
   */
  function updateDonationTotalDisplay() {
    const amount = getTotalDonationAmount();

    $form
      .find(selectors.totalDonationAmount)
      .text(amount > 0 ? window.RR.numberFormatter.format(amount) : window.RR.i18n.noDonation);
  }

  /**
   * Display the selected fundraising organization's details
   *
   * @param registrantIndex
   * @param selectedFundraisingOrganization
   */
  function displayFundraisingOrganizationDetails(registrantIndex, selectedFundraisingOrganization) {
    const $donationContainer = $form
      .find(selectors.donationContainer)
      .filter(`[data-registrant-index="${registrantIndex}"]`);
    const $fundraisingOrganizationDetails = $donationContainer.find(selectors.fundraisingOrganizationDetails);

    // Update the fundraising organization details for display
    $fundraisingOrganizationDetails.toggleClass(
      'hidden',
      selectedFundraisingOrganization.logo === null && selectedFundraisingOrganization.description === '',
    );
    $fundraisingOrganizationDetails
      .find(selectors.fundraisingOrganizationLogo)
      .attr('src', selectedFundraisingOrganization.logo)
      .toggleClass('hidden', selectedFundraisingOrganization.logo === null);
    $fundraisingOrganizationDetails
      .find(selectors.fundraisingOrganizationDescription)
      .html(selectedFundraisingOrganization.description);
  }

  /**
   * Trigger the display of the fundraising organization input
   *
   * @param $input
   */
  function triggerFundraisingOrganizationDisplay($input) {
    const $donationContainer = $input.closest(selectors.donationContainer);
    const $organizationDetails = $donationContainer.find(selectors.fundraisingOrganizationDetails);

    // If there is only one fundraising organization, pre-select it and display the single fundraising organization
    // header
    if ($input.find('option:gt(0)').length === 1) {
      const $fundraisingOrganization = $input.find('option:gt(0):first');
      $fundraisingOrganization.prop('selected', true);

      // Hide the input and select the charity
      $input.prop('required', false); // Won't be able to focus a hidden input, so let the backend handle it
      $donationContainer.find(selectors.fundraisingOrganizationContainer).addClass('hidden');

      const registrantIndex = $donationContainer.data('registrant-index');

      // Display the fundraising organization's details
      displayFundraisingOrganizationDetails(
        registrantIndex,
        getFundraisingOrganization(registrantIndex, $input.val()),
      );

      // Display the header for single organizations
      $organizationDetails
        .find(selectors.singleFundraisingOrganizationHeader)
        .removeClass('hidden')
        .text($fundraisingOrganization.text());
    } else {
      $donationContainer.find(selectors.fundraisingOrganizationContainer).removeClass('hidden');
      $donationContainer.find(selectors.requiredLabelContainer).removeClass('hidden');
      $organizationDetails.find(selectors.singleFundraisingOrganizationHeader).addClass('hidden');
      $input.prop('required', true);
    }
  }

  /**
   * sort based on display order
   * @param a
   * @param b
   * @return {number}
   */
  function sortCustomDisplayOrder(a, b) {
    return a.displayOrder.toString() - b.displayOrder.toString();
  }

  /**
   * Sort alphabetically
   * @param a
   * @param b
   * @return {number}
   */
  function sortAlphabetical(a, b) {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
  }

  /**
   * Populate the fundraising organization options
   *
   * @param $input
   * @param fundraisingOrganizationsToPopulate
   */
  function populateFundraisingOrganizations(
    $input,
    fundraisingOrganizationsToPopulate,
    registrantIndex,
  ) {
    $input
      .find('option')
      .not(selectors.fundraisingOrganizationInputEmptyValue)
      .remove();
    let totalFundraisingOrganizationsToPopulate;
    const preSelectedFundraisingOrganization = window.RR.preSelectedFundraisingOrganizations[registrantIndex - 1];

    if (window.RR.organizationDisplayTypeIsAlphabetical) {
      const featuredFundraisingOrganizations = fundraisingOrganizationsToPopulate
        .filter((organization) => organization.isFeatured);
      const notFeaturedFundraisingOrganizations = fundraisingOrganizationsToPopulate
        .filter((organization) => !organization.isFeatured);

      featuredFundraisingOrganizations.sort(
        window.RR.featuredOrganizationDisplayTypeIsAlphabetical
          ? sortAlphabetical
          : sortCustomDisplayOrder,
      );

      notFeaturedFundraisingOrganizations.sort(sortAlphabetical);
      totalFundraisingOrganizationsToPopulate = featuredFundraisingOrganizations
        .concat(notFeaturedFundraisingOrganizations);
    }

    // Populate the fundraising organizations depending on the display order type
    (window.RR.organizationDisplayTypeIsAlphabetical
      ? totalFundraisingOrganizationsToPopulate
      : fundraisingOrganizationsToPopulate).forEach(
      (fundraisingOrganization) => $input.append(`
            <option value="${fundraisingOrganization.id}"
                    data-featured="${fundraisingOrganization.featured}"
                    data-display-order="${fundraisingOrganization.displayOrder}"
                    ${fundraisingOrganization.id === preSelectedFundraisingOrganization ? 'selected' : ''}
                    >${fundraisingOrganization.name}</option>
          `),
    );
  }

  /**
   * Initialize the fundraising organizations input
   *
   * @param $input
   * @param registrantIndex
   */
  function initializeFundraisingOrganizations($input, registrantIndex) {
    populateFundraisingOrganizations(
      $input,
      filterOrganizationForRegistrant(registrantIndex),
      registrantIndex,
    );

    // Attempt to pre-populate from the data-selected attribute
    const selected = $input.data('selected');
    if (selected) {
      $input.val(selected);
    }

    // If there is only one organization, pre-select and display the organization information
    if ($input.find('option:gt(0)').length === 1) {
      triggerFundraisingOrganizationDisplay($input);
    }
  }

  /**
   * Populate the donation type (fundraiser) options
   *
   * @param $input
   * @param registrantIndex
   * @param registrantsToPopulate
   * @param teamsToPopulate
   */
  function populateDonationType(
    $input,
    registrantIndex,
    registrantsToPopulate = registrants,
    teamsToPopulate = teams[registrantIndex - 1],
  ) {
    const selectedOption = $input.val();
    const myself = registrants.find((registrant) => registrant.index === registrantIndex);
    const hasMyself = typeof myself !== 'undefined';
    const $generalDonationOption = $input.find('option[value="DONATION"]').clone();
    const selectedOrganization = getSelectedFundraisingOrganization(registrantIndex);

    $input.find('option:gt(0)').remove();

    // Append the registrants **except `myself`** that can receive donations
    registrantsToPopulate
      .filter((registrant) => {
        // Filter the current registrant
        // remove `myself` if it is not an option for receiving donations
        if (!hasMyself) {
          if (registrant.index === registrantIndex) {
            return false;
          }
        }

        // Filter registrants that are not available on the selected organization
        if (selectedOrganization) {
          const allowedOrganizations = filterOrganizationForRegistrant(registrant.index);

          if (!allowedOrganizations.some((organization) => organization.uuid === selectedOrganization.uuid)) {
            return false;
          }
        }

        // Otherwise, the registrant is allowed
        return true;
      })
      .forEach((registrant) => $input.append(
        `<option value="registrant-${registrant.index}">
          ${window.RR.i18n.registrantFundraisingRecipient.replace('%registrant_name%', registrant.displayName)}
        </option>`,
      ));

    // Append the teams that can receive donations
    teamsToPopulate
      .filter((team) => {
        if (selectedOrganization) {
          const allowedOrganizations = filterOrganizationsForTeam(
            fundraisingOrganizations[registrantIndex - 1],
            team,
          );

          // Filter teams that do not allow the selected organization
          if (!allowedOrganizations.some((organization) => organization.uuid === selectedOrganization.uuid)) {
            return false;
          }
        }

        // Otherwise, the team can be included
        return true;
      })
      .forEach((team) => {
        const teamId = team.isProvisional ? `temp-${team.id}` : team.id;

        $input.append(
          `<option value="team-${teamId}">
                        ${window.RR.i18n.teamFundraisingRecipient.replace('%team_name%', team.name)}
                    </option>`,
        );
      });

    // Re-add the general donation option if applicable
    if ($generalDonationOption.length) {
      $input.append($generalDonationOption);
    }

    // Attempt to re-select the original option
    $input.val(selectedOption || '');

    // If there is only one option and none selected, let's select the option for them
    // TODO: Should we hide the section and input when there won't be additional options?
    if (($input.val() === '' || $input.val() === null) && $input.find('option:gt(0)').length === 1) {
      $input.val($input.find('option:gt(0):first').val());
    }

    // TODO: If no options, we need to add the general option and select it for them
  }

  /**
   * Initialize the donation type input
   *
   * @param $input
   * @param registrantIndex
   */
  function initializeDonationType($input, registrantIndex) {
    populateDonationType($input, registrantIndex);

    // Attempt to pre-populate from the data-selected attribute
    const selected = $input.data('selected');
    if (selected) {
      $input.val(selected);
    }
  }

  /**
   * Populate the copy donation inputs for each donation
   */
  function populateCopyDonationInputs() {
    // Update the copy donation input for the other donations
    $form.find(selectors.donationContainer).each(
      (index, container) => {
        const $input = $(container).find(selectors.copyDonationInput);
        const $copyDonationContainer = $input.closest('.form-group');
        const $currentDonation = $input.closest(selectors.donationContainer);
        const $otherDonations = $form.find(selectors.donationContainer).not($currentDonation);
        const $currentSelection = $input.val();

        // If there are other donations, show the copy option and populate the input
        $copyDonationContainer.toggleClass('hidden', $otherDonations.length === 0);
        $input.find('option:gt(0)').remove();

        if ($otherDonations.length > 0) {
          $otherDonations.each((donationIndex, element) => {
            const $donation = $(element);
            const registrantIndex = $donation.data('registrant-index');
            const donor = registrants.filter((registrant) => registrant.index === registrantIndex).shift();

            if (typeof donor !== 'undefined') {
              $input.append(`<option value="${donor.index}">${donor.displayName}</option>`);
            }
          });
        }

        // Re-select the original value
        $input.val($currentSelection);
      },
    );
  }

  /**
   * Attempt to opt-in for a tax receipt if possible. This is based on fundraising organization settings as well as
   * if the donation amount meets the minimum requirements
   *
   * @param registrantIndex
   */
  function attemptToOptInForTaxReceipt(registrantIndex) {
    const $donationContainer = $form
      .find(`${selectors.donationContainer}[data-registrant-index="${registrantIndex}"]`);
    const $fundraisingOrganizationInput = $donationContainer.find(selectors.fundraisingOrganizationInput);
    const fundraisingOrganization = getFundraisingOrganization(registrantIndex, $fundraisingOrganizationInput.val());
    const donationAmount = getDonationAmount(registrantIndex);
    const $taxReceiptInput = $donationContainer.find(selectors.donationTaxReceiptInput);

    // Only attempt to opt-in if the tax receipt is allowed for the fundraising organization
    if (typeof fundraisingOrganization === 'undefined' || !fundraisingOrganization.canRequestTaxReceipt) {
      return;
    }

    // Now we compare the donation amount against the fundraising organization's minimum requirements
    if (donationAmount >= window.parseMoney(fundraisingOrganization.minimumAmountForTaxReceipt, window.RR.locale)) {
      $taxReceiptInput.prop('checked', true);
    } else {
      $taxReceiptInput.prop('checked', false);
    }
  }

  /**
   * Toggle the display of the fundraising organization specific settings
   *
   * @param registrantIndex
   * @param $container
   * @param fundraisingOrganization
   */
  function toggleFundraisingOrganizationSpecificSettings(registrantIndex, $container, fundraisingOrganization) {
    const $donationType = $container.find(selectors.donationTypeInput);
    const $taxReceipt = $container.find(selectors.donationTaxReceiptContainer);
    const $taxReceiptInput = $taxReceipt.find(selectors.donationTaxReceiptInput);
    const $taxReceiptMinimumContainer = $taxReceipt.find(selectors.donationMinimumTaxReceiptAmountContainer);
    const $taxReceiptOptIn = $taxReceipt.find(selectors.donationTaxReceiptOptIn);
    const $taxReceiptForce = $taxReceipt.find(selectors.donationTaxReceiptForce);
    const $taxReceiptNotice = $taxReceipt.find(selectors.donationTaxReceiptNotice);
    const subEvent = getRegistrantSubEvent(registrantIndex);

    // Filter the available fundraisers
    if (!fundraisingOrganization.isPledgingEnabled || !subEvent?.hasParticipantFundraising) {
      populateDonationType($donationType, registrantIndex, [], []);
    } else if (fundraisingOrganization.requiresPermissions) {
      const teamsToPopulate = teams[registrantIndex - 1]
        .filter((team) => team.fundraisingOrganizations.includes(fundraisingOrganization.uuid));
      const availableTeams = teams[registrantIndex - 1].map((team) => team.id);
      const registrantsToPopulate = registrants.filter(
        (registrant) => registrant.teamId === null || availableTeams.includes(registrant.teamId),
      );

      populateDonationType($donationType, registrantIndex, registrantsToPopulate, teamsToPopulate);
    } else {
      // Re-populate the donation type with original values
      populateDonationType($donationType, registrantIndex);
    }

    $donationType.prop('required', true);

    // Toggle display of the tax receipt information
    $taxReceipt.toggleClass('hidden', !fundraisingOrganization.canRequestTaxReceipt);
    if (!fundraisingOrganization.canRequestTaxReceipt) {
      $taxReceiptInput.prop('checked', false);
    } else {
      $taxReceiptNotice.toggleClass('hidden', !fundraisingOrganization.isTaxReceiptIssuingApproved);
      $taxReceiptForce
        .toggleClass('hidden', !fundraisingOrganization.isTaxReceiptRequired)
        .toggleClass('display-block', fundraisingOrganization.isTaxReceiptRequired);

      $taxReceiptOptIn
        .toggleClass('hidden', fundraisingOrganization.isTaxReceiptRequired)
        .toggleClass('display-block', !fundraisingOrganization.isTaxReceiptRequired);

      // Make the field disabled if the fundraising organization has forced tax receipts
      $taxReceiptInput.prop('disabled', fundraisingOrganization.isTaxReceiptRequired);

      $taxReceiptMinimumContainer.toggleClass('hidden', fundraisingOrganization.minimumAmountForTaxReceipt === 0);
      $taxReceiptMinimumContainer
        .find(selectors.donationMinimumTaxReceiptAmount)
        .text(window.RR.numberFormatter.format(fundraisingOrganization.minimumAmountForTaxReceipt));
    }

    // We'll be nice and attempt to opt the user in for a tax receipt
    attemptToOptInForTaxReceipt(registrantIndex);
  }

  /**
   * Initialize the donation container when created
   *
   * @param $donationContainer
   */
  function initializeDonationContainer($donationContainer) {
    const registrantIndex = $donationContainer.data('registrant-index');

    initializeFundraisingOrganizations(
      $donationContainer.find(selectors.fundraisingOrganizationInput),
      registrantIndex,
    );
    initializeDonationType($donationContainer.find(selectors.donationTypeInput), registrantIndex);

    $donationContainer.popover({
      placement: 'top',
      container: $donationContainer,
      html: true,
      selector: '[data-toggle="popover"]',
    });

    // Populate the copy donation inputs for all donations
    populateCopyDonationInputs();
  }

  /**
   * The function that gets how much the user has donated toward the required organizations - to be used in a reducer
   * @param accumulator
   * @param element
   * @returns {*}
   */
  function getAmountTowardRequiredOrganizations(accumulator, element) {
    const $donationContainer = $(element).find(selectors.donationContainer);

    // the donation form hasn't been filled out yet
    if (!$donationContainer.length) {
      return accumulator;
    }

    const registrantIndex = $donationContainer.data('registrant-index');

    const selectedOrganization = getSelectedFundraisingOrganization(registrantIndex);

    // they haven't chosen an organization yet
    if (!selectedOrganization) {
      return accumulator;
    }

    // they haven't chosen an organization part of the required organizations list
    if (
      !globalMandatoryDonationSettings
        .includedFundraisingOrganizationIds
        .includes(parseInt(selectedOrganization.id, 10))
    ) {
      return accumulator;
    }

    return accumulator + getDonationAmount(registrantIndex);
  }

  /**
   * Checks if the donated amount is enough, whether it's toward a required organization or toward any organization
   * @param element
   * @returns {boolean}
   */
  function checkIfDonatedAmountIsEnough(element) {
    const $donationContainer = $(element).find(selectors.donationContainer);

    // the donation form hasn't been filled out yet
    if (!$donationContainer.length) {
      return false;
    }

    const registrantIndex = $donationContainer.data('registrant-index');
    const donationSettings = getMandatoryDonationSettings(registrantIndex);

    // the mandatory donation settings isn't available
    if (!donationSettings) {
      return true;
    }

    // if the minimum only applies to selected orgs, check if the user chose one of them
    if (!donationSettings.appliesToAllFundraisingOrganizations) {
      const selectedOrganization = getSelectedFundraisingOrganization(registrantIndex);

      // they didn't chose an organization
      if (!selectedOrganization) {
        return false;
      }

      // they didn't chose an organization that's part of the required orgs
      if (
        !donationSettings
          .includedFundraisingOrganizationIds
          .includes(parseInt(selectedOrganization.id, 10))
      ) {
        return false;
      }
    }

    return getDonationAmount(registrantIndex) >= donationSettings.minimumAmount;
  }

  /**
   * Whether to enable or disable the submit button
   * @param enabled
   */
  function toggleSubmit(enabled) {
    if (enabled) {
      $form
        .find('button[type="submit"]')
        .removeClass('disabled')
        .attr('aria-disabled', false)
        .attr('data-disabled', false);
      return;
    }

    $form
      .find('button[type="submit"]')
      .addClass('disabled')
      .attr('aria-disabled', true)
      .attr('data-disabled', true);
  }

  /**
   * Is submit disabled?
   * @returns {*}
   */
  function isSubmitDisabled() {
    return $form.find('button[type="submit"]').attr('data-disabled') === 'true';
  }

  /**
   * Lots of ifs, ands, and buts to see if the mandatory donation requirements are met. Buckle up.
   * @returns {boolean}
   */
  function checkIfMandatoryDonationRequirementsAreMet() {
    let globalConditionsMet = true;
    let registrantsConditionsMet = true;

    $form
      .find(selectors.container)
      .each((index, element) => {
        const $errorContainer = $(element).find(selectors.mandatoryDonationText);
        if ($errorContainer.length && $errorContainer.data('validate') === false) {
          registrantsConditionsMet = false;
          return false;
        }

        return true;
      });

    if (registrantsConditionsMet && globalMandatoryDonationSettings) {
      if (globalMandatoryDonationSettings.appliesToAllFundraisingOrganizations) {
        globalConditionsMet = getTotalDonationAmount() >= globalMandatoryDonationSettings.minimumAmount;
      } else if (globalMandatoryDonationSettings.minimumAmountIsCombined) {
        globalConditionsMet = $form
          .find(selectors.container)
          .get()
          .reduce(getAmountTowardRequiredOrganizations, 0) >= globalMandatoryDonationSettings.minimumAmount;
      } else {
        globalConditionsMet = $form
          .find(selectors.container)
          .get()
          .some(checkIfDonatedAmountIsEnough);
      }
    }

    if (globalConditionsMet && registrantsConditionsMet) {
      if (globalConditionsMet) {
        $form.find(selectors.globalMandatoryDonationText).addClass('hidden').data('validate', true);
      }

      // normally we depend on enableButtonActions() to re-enable the button, but that only gets called
      // when there are multiple registrants. so when there's only 1 registrant, we'll do it ourselves
      if (hasSingleRegistrant()) {
        toggleSubmit(true);
      }
    } else {
      toggleSubmit(false);
      if (!globalConditionsMet) {
        $form.find(selectors.globalMandatoryDonationText).removeClass('hidden').data('validate', false);
      }
    }

    return globalConditionsMet && registrantsConditionsMet;
  }

  /**
   * Remove the disabled states
   */
  function enableButtonActions() {
    $form.find(selectors.container).removeClass('donation-container--inactive');
    $form.find(selectors.editDonation).removeClass('disabled');
    $form.find(selectors.addDonation).removeClass('disabled');
    $form.find(selectors.removeDonation).removeClass('disabled');

    if (checkIfMandatoryDonationRequirementsAreMet()) {
      toggleSubmit(true);
    }
  }

  /**
   * Action taken when an amount has been selected
   *
   * @param event
   */
  function selectAmount(event) {
    const $this = $(event.currentTarget);
    const $donationContainer = $this.closest(selectors.donationContainer);
    const $customAmountContainer = $donationContainer.find(selectors.customDonationAmountContainer);
    const $customAmountInput = $customAmountContainer.find(selectors.customDonationAmountInput);
    const $amountInputs = $donationContainer.find(selectors.donationAmountInput);
    const $isFeeAppendedContainer = $donationContainer.find(selectors.isFeeAppendedContainer);
    const $selectedAmount = $amountInputs.filter(':checked');
    const $organizationInput = $donationContainer.find(selectors.fundraisingOrganizationInput);

    // No amount selected, update the total
    if (!$selectedAmount.length) {
      updateDonationTotalDisplay();
      return;
    }

    if ($selectedAmount.val() === 'other') {
      $customAmountContainer.removeClass('hidden');
      $customAmountInput.focus().attr('required', true);
    } else {
      $customAmountContainer.addClass('hidden');
      $customAmountInput.val('').attr('required', false);

      attemptToOptInForTaxReceipt($donationContainer.data('registrant-index'));
    }

    $isFeeAppendedContainer.removeClass('hidden');

    // Display the organization selector and trigger the change event on the input
    // In the case of single organizations, it will be displayed before an amount is chosen
    // without triggering the change event, so that's why we need to do that here
    triggerFundraisingOrganizationDisplay($organizationInput);
    $organizationInput.trigger('change');
  }

  /**
   * Action taken when a fundraising organization has been selected
   * It triggers the toggling of the fundraising organization specific settings
   *
   * @param event
   */
  function selectFundraisingOrganization(event) {
    const $input = $(event.currentTarget);
    const $container = $input.closest(selectors.container);
    const $donationContainer = $input.closest(selectors.donationContainer);
    const selectedFundraisingOrganization = getFundraisingOrganization(
      $donationContainer.attr('data-registrant-index'),
      $input.val(),
    );
    const $donationSettingsContainer = $donationContainer.find(selectors.donationSettingsContainer);
    const $fundraisingOrganizationDetails = $donationContainer.find(selectors.fundraisingOrganizationDetails);

    // If the fundraising organization could not be found, hide the donation settings and organization details
    if (typeof selectedFundraisingOrganization === 'undefined') {
      $donationSettingsContainer.addClass('hidden');
      $fundraisingOrganizationDetails.addClass('hidden');
      return;
    }

    if (!checkIfDonatedAmountIsEnough($container)) {
      $donationSettingsContainer.addClass('hidden');
      $fundraisingOrganizationDetails.addClass('hidden');
      $container.find(selectors.mandatoryDonationText).removeClass('hidden').data('validate', false);
      return;
    }

    // Hide the error message
    $container.find(selectors.mandatoryDonationText).addClass('hidden').data('validate', true);

    displayFundraisingOrganizationDetails(
      $donationContainer.data('registrant-index'),
      selectedFundraisingOrganization,
    );

    toggleFundraisingOrganizationSpecificSettings(
      $donationContainer.data('registrant-index'),
      $donationSettingsContainer,
      selectedFundraisingOrganization,
    );

    // Display the donation settings
    $donationSettingsContainer.removeClass('hidden');

    // Ensure the donation amount is now required so the user doesn't miss it
    $($donationContainer.find(selectors.donationAmountInput)[0]).prop('required', true);
  }

  /**
   * Action taken when a donation type is selected
   * This can update the available organizations if the selected donation type allows additional options
   * @param event
   */
  function selectDonationType(event) {
    const $this = $(event.currentTarget);
    const $donationContainer = $this.closest(selectors.donationContainer);
    const $organizationInput = $donationContainer.find(selectors.fundraisingOrganizationInput);
    const registrantIndex = $donationContainer.data('registrant-index');

    if ($this.val() === '' || $this.val() === null) {
      return;
    }

    // Filter the available organizations for the registrant or team selection
    let organizations = filterOrganizationsForSubEvent(
      fundraisingOrganizations[registrantIndex - 1],
      getRegistrantSubEvent(registrantIndex),
    );

    if ($this.val().includes('team-')) {
      const selectedTeam = teams[registrantIndex - 1].find((team) => {
        if (team.isProvisional) {
          return `team-temp-${team.id}` === $this.val();
        }

        return `team-${team.id}` === $this.val();
      });
      organizations = filterOrganizationsForTeam(organizations, selectedTeam);
    } else if ($this.val().includes('registrant-')) {
      const selectedRegistrant = registrants
        .find((registrant) => `registrant-${registrant.index}` === $this.val());
      organizations = filterOrganizationsForTeam(organizations, getRegistrantTeam(selectedRegistrant.index));
    }

    // Change the available organizations
    const selectedOrganization = $organizationInput.val();
    const hasSelectedOrganization = organizations
      .some((organization) => organization.id === Number(selectedOrganization));
    populateFundraisingOrganizations($organizationInput, organizations, registrantIndex);
    triggerFundraisingOrganizationDisplay($organizationInput);

    // Repopulate the selected organization
    if (hasSelectedOrganization) {
      $organizationInput.val(selectedOrganization).trigger('change');
      // If it is not available and there is only one organization, select it
    } else if (organizations.length === 1) {
      $organizationInput.val($organizationInput.find('option:gt(0):first').val()).trigger('change');
      // Otherwise, clear out the organization selection
    } else {
      // We don't want to trigger change here as it will hide the settings
      $organizationInput.val('');
      triggerFundraisingOrganizationDisplay($organizationInput);
    }
  }

  /**
   * Action taken when a donor type has been selected
   * If anonymous or company, a donor display name input field is shown and made required
   *
   * @param event
   */
  function selectDonorType(event) {
    const $this = $(event.currentTarget);
    const $donationContainer = $this.closest(selectors.donationContainer);
    const $donorTypeInputs = $donationContainer.find(selectors.donorTypeInput);
    const $donorNameContainer = $this
      .closest(selectors.donationContainer)
      .find(selectors.donationDonorDisplayNameContainer);
    const $donorNameInput = $donorNameContainer.find(selectors.donationDonorDisplayNameInput);
    const $donorAliasedName = $donorNameContainer.find(selectors.donationDonorDisplayNameAliased);
    const $donorCompanyName = $donorNameContainer.find(selectors.donationDonorDisplayNameCompany);
    const selectedType = $donorTypeInputs.filter(':checked').val();

    if (selectedType === 'INDIVIDUAL') {
      $donorNameContainer.addClass('hidden');
      $donorNameInput.val('').prop('required', false);
    } else if (selectedType === 'ALIASED') {
      $donorNameContainer.removeClass('hidden');
      $donorNameInput.prop('required', true);
      $donorAliasedName.removeClass('hidden');
      $donorCompanyName.addClass('hidden');
    } else if (selectedType === 'COMPANY') {
      $donorNameContainer.removeClass('hidden');
      $donorNameInput.prop('required', true);
      $donorCompanyName.removeClass('hidden');
      $donorAliasedName.addClass('hidden');
    }
  }

  /**
   * Update the content of the collapsed donation display
   *
   * @param event
   * @param registrantIndex
   */
  function updateCollapsedContent(event, registrantIndex = null) {
    let $container;
    let $donationContainer;
    let $collapsedContainer;

    if (registrantIndex) {
      $donationContainer = $form
        .find(selectors.donationContainer)
        .filter(`[data-registrant-index="${registrantIndex}"]`);
      $container = $donationContainer.closest(selectors.container);
      $collapsedContainer = $container.find(selectors.collapsedDonationContainer);
    } else {
      const $this = $(event.currentTarget);
      $donationContainer = $this.closest(selectors.donationContainer);
      $container = $donationContainer.closest(selectors.container);
      $collapsedContainer = $container.find(selectors.collapsedDonationContainer);

      // eslint-disable-next-line no-param-reassign
      registrantIndex = $donationContainer.data('registrant-index');
    }

    $collapsedContainer
      .find(selectors.collapsedDonationAmount)
      .html(window.RR.numberFormatter.format(getDonationAmount(registrantIndex)));

    const selectedOrganization = getSelectedFundraisingOrganization(registrantIndex);
    $collapsedContainer
      .find(selectors.collapsedDonationFundraisingOrganizationName)
      .html(selectedOrganization ? selectedOrganization.name : '');
  }

  /**
   * Toggle the fundraising organization questions
   *
   * @param event
   */
  function toggleFundraisingOrganizationQuestions(event) {
    const $this = $(event.currentTarget);
    const $donationContainer = $this.closest(selectors.donationContainer);
    const $donationSettingsContainer = $donationContainer.find(selectors.donationSettingsContainer);
    const $questions = $donationSettingsContainer.find(selectors.fundraisingOrganizationQuestions);
    const selectedFundraisingOrganization = getFundraisingOrganization(
      $donationContainer.data('registrant-index'),
      $this.val(),
    );

    if (typeof selectedFundraisingOrganization === 'undefined' || !selectedFundraisingOrganization.hasQuestions) {
      $questions.addClass('hidden');
      return;
    }

    $questions
      .html($questions.html().replace(/__FUNDRAISING_ORGANIZATION_NAME__/g, selectedFundraisingOrganization.name))
      .removeClass('hidden');
  }

  /**
   * Collapse all donation forms
   */
  function collapseDonations() {
    $form.find(selectors.donationContainer).each(
      (index, element) => {
        const $donationContainer = $(element);
        const $container = $donationContainer.closest(selectors.container);
        let $collapsedContainer = $container.find(selectors.collapsedDonationContainer);
        const registrantIndex = $donationContainer.data('registrant-index');

        $donationContainer.addClass('hidden');
        $container.find(selectors.editDonation).removeClass('hidden');
        $container.find('.panel-heading').find(selectors.removeDonation).addClass('hidden');

        if ($collapsedContainer.length) {
          $collapsedContainer.removeClass('hidden');
        } else {
          $collapsedContainer = $(window.RR.donationCollapsedTemplate.replace(/__INDEX__/g, registrantIndex));
          $container.find('.panel-body').prepend($collapsedContainer);
        }

        // Add some color to the panel
        $container.addClass('donation-container--complete');

        // Update the displayed values
        updateCollapsedContent(null, registrantIndex);

        // Remove the required attribute since we can't focus hidden fields
        $donationContainer.find(':input[data-required="true"]').prop('required', false);
      },
    );

    // Disable buttons - only when there is more than one donation possible
    if ($form.find(selectors.container).length > 1) {
      toggleSubmit(false);
      $form.find(selectors.editDonation).addClass('disabled');
      $form.find(selectors.addDonation).addClass('disabled');
      $form.find(selectors.removeDonation).addClass('disabled');
    }
  }

  /**
   * Expand the donation form of a registrant
   *
   * @param registrantIndex
   */
  function expandDonation(registrantIndex) {
    const $donationContainer = $form
      .find(selectors.donationContainer)
      .filter(`[data-registrant-index="${registrantIndex}"]`);
    const $container = $donationContainer.closest(selectors.container);
    const $collapseContainer = $container.find(selectors.collapsedDonationContainer);
    const $donationAmountOptionsContainer = $donationContainer.find(selectors.donationAmountOptionsContainer);
    const donationSettings = getMandatoryDonationSettings(registrantIndex);

    // the mandatory donation settings isn't available
    if (!globalMandatoryDonationSettings && !donationSettings) {
      $donationAmountOptionsContainer.find('.required').addClass('hidden');
    }

    // Ghost the other containers
    $form.find(selectors.container).addClass('donation-container--inactive');
    $container.find(selectors.editDonation).addClass('hidden');
    $donationContainer.removeClass('hidden');
    $collapseContainer.addClass('hidden');

    // Remove that coloring
    $container.removeClass('donation-container--complete donation-container--inactive');
    $container.find('.panel-heading').find(selectors.removeDonation).removeClass('hidden');

    // Re-add the required attributes that should be there
    $container.find(':input[data-required="true"]').filter(':visible').prop('required', true);

    // Enable actions
    $container.find(selectors.editDonation).removeClass('disabled');
    $container.find(selectors.addDonation).removeClass('disabled');
    $container.find(selectors.removeDonation).removeClass('disabled');
  }

  /**
   * Add a donation for a registrant
   *
   * @param event
   */
  function addDonation(event) {
    const $button = $(event.currentTarget);
    const $container = $button.closest(selectors.container);
    const registrantIndex = $button.data('registrant-index');
    const $template = $(window.RR.donationTemplates[registrantIndex - 1].replace(/__INDEX__/g, registrantIndex));
    const $containerBody = $container.find('.panel-body');

    $containerBody.find(selectors.addDonationContainer).remove();
    $containerBody.prepend($template);

    initializeDonationContainer($template);

    // Display the donation form
    collapseDonations();
    expandDonation(registrantIndex);

    $container.find(selectors.mandatoryDonationText).removeClass('hidden').data('validate', false);

    // When there is only one registrant, we want them to be able to continue without an amount and not apply
    if (hasSingleRegistrant()) {
      $form.find(selectors.applyDonation).remove();
      $form.find(selectors.donationAmountInput).attr('required', false);
      $form.find(selectors.fundraisingOrganizationInput).attr('required', false);
    }
  }

  /**
   * Apply the changes and enable the other actions
   *
   * @param event
   */
  function applyDonation(event) {
    const $this = $(event.currentTarget);
    const $container = $this.closest(selectors.container);
    const $donationContainer = $container.find(selectors.donationContainer);
    const $requiredInputs = $donationContainer
      .find(':input:visible')
      .filter((index, input) => $(input).is(':invalid'));

    // Validate
    $requiredInputs.each((index, input) => {
      const $input = $(input);
      const $formGroup = $input.closest('.form-group');

      $formGroup.addClass('has-error').find('.help-block').remove();
      $formGroup.append(`<p class="help-block container-fluid">${window.RR.i18n.requiredInput}</p>`);

      // Add a listener to remove the error state
      $input.on('change', (e) => {
        const $inputChanged = $(e.currentTarget);
        $inputChanged
          .closest('.form-group')
          .removeClass('has-error')
          .find('.help-block')
          .remove();
      });
    });

    if ($requiredInputs.length === 0) {
      collapseDonations();
      enableButtonActions();
    } else {
      $requiredInputs[0].focus();
    }
  }

  /**
   * Edit the donation of a registrant
   *
   * @param event
   */
  function editDonation(event) {
    const $this = $(event.currentTarget);
    const $container = $this.closest(selectors.container);
    const $donationContainer = $container.find(selectors.donationContainer);

    collapseDonations();
    expandDonation($donationContainer.data('registrant-index'));

    // Remove that coloring
    $container.removeClass('donation-container--complete');
  }

  /**
   * Remove the donation of a registrant
   *
   * @param event
   */
  function removeDonation(event) {
    const $this = $(event.currentTarget);
    const $container = $this.closest(selectors.container);
    const $donationContainer = $container.find(selectors.donationContainer);
    const registrantIndex = $donationContainer.data('registrant-index');
    const $containerBody = $container.find('.panel-body');

    // Remove the donation
    $containerBody.find(selectors.collapsedDonationContainer).remove();
    $containerBody.find(selectors.donationContainer).remove();
    $container.find(selectors.editDonation).addClass('hidden');
    $container.find(selectors.mandatoryDonationText).addClass('hidden').data('validate', false);
    $container.find('.panel-heading').find(selectors.removeDonation).addClass('hidden');
    $container.removeClass('donation-container--complete');

    // Add an add button
    const template = $(window.RR.donationAddTemplate.replace(/__INDEX__/g, registrantIndex));
    $containerBody.prepend(template);

    // Remove copy donation references for this donation
    populateCopyDonationInputs();
    enableButtonActions();
  }

  /**
   * Copy the donation of another registrant to the currency registrant
   *
   * @param event
   */
  function copyDonation(event) {
    const $this = $(event.currentTarget);

    // Do nothing if no registrant is selected
    if ($this.val() === '') {
      return;
    }

    const $currentRegistrantDonation = $this.closest(selectors.donationContainer);
    const $copyRegistrantDonation = $form
      .find(`${selectors.donationContainer}[data-registrant-index="${$this.val()}"]`);

    $currentRegistrantDonation
      .find(selectors.donationAmountInput)
      .filter(
        (index, element) => (
          $(element).val() === $copyRegistrantDonation.find(`${selectors.donationAmountInput}:checked`).val()
        ),
      )
      .prop('checked', true)
      .trigger('change');

    $currentRegistrantDonation
      .find(selectors.customDonationAmountInput)
      .val($copyRegistrantDonation.find(selectors.customDonationAmountInput).val())
      .trigger('change');

    $currentRegistrantDonation
      .find(selectors.isFeeAppendedInput)
      .prop('checked', $copyRegistrantDonation.find(selectors.isFeeAppendedInput).is(':checked'));

    $currentRegistrantDonation
      .find(selectors.fundraisingOrganizationInput)
      .val($copyRegistrantDonation.find(selectors.fundraisingOrganizationInput).val())
      .trigger('change');

    $currentRegistrantDonation
      .find(selectors.donationTypeInput)
      .val($copyRegistrantDonation.find(selectors.donationTypeInput).val());

    $currentRegistrantDonation
      .find(selectors.donationTaxReceiptInput)
      .prop('checked', $copyRegistrantDonation.find(selectors.donationTaxReceiptInput).is(':checked'));

    $currentRegistrantDonation
      .find(selectors.isAnonymousInput)
      .prop('checked', $copyRegistrantDonation.find(selectors.isAnonymousInput).is(':checked'));

    $currentRegistrantDonation
      .find(selectors.isAmountAnonymousInput)
      .prop('checked', $copyRegistrantDonation.find(selectors.isAmountAnonymousInput).is(':checked'));

    $currentRegistrantDonation
      .find(selectors.donorTypeInput)
      .filter(
        (index, element) => (
          $(element).val() === $copyRegistrantDonation.find(`${selectors.donorTypeInput}:checked`).val()
        ),
      )
      .prop('checked', true)
      .trigger('change');

    $currentRegistrantDonation
      .find(selectors.donationDonorDisplayNameInput)
      .val($copyRegistrantDonation.find(selectors.donationDonorDisplayNameInput).val());

    $currentRegistrantDonation
      .find(selectors.donationDonorMessageInput)
      .val($copyRegistrantDonation.find(selectors.donationDonorMessageInput).val());
  }

  /**
   * Persist the donations
   *
   * @param event
   * @param confirmed
   */
  function persistDonations(event, confirmed = false) {
    event.preventDefault();

    if (isSubmitDisabled()) {
      $snackBar.snackBar('add', {
        type: 'danger',
        icon: 'exclamation-circle',
        content: $form.find('[data-js-donation-minimum-alert-text]').text().trim(),
      });

      $form.preventDoubleSubmission('reEnable');

      return;
    }

    const amount = getTotalDonationAmount();

    if (
      !confirmed
      && parseInt(window.RR.donationConfirmAmount, 10) !== 0
      && amount >= window.RR.donationConfirmAmount
    ) {
      $.fn.confirmDialog({
        bs3: true,
        bodyContent: window.RR.i18n.confirmLargeDonationCopy
          .replace('%donationAmount%', window.RR.numberFormatter.format(amount)),
        callbacks: {
          confirmed: () => {
            persistDonations(event, true);
          },
          cancelled: () => {
            $form.trigger('raceRoster.preventDoubleSubmission.reEnable');
          },
        },
        confirmButtonContent: window.RR.i18n.ok,
      });

      return;
    }

    // Enable any tax receipt inputs for form serialization. We'll set these back afterwards.
    $form
      .find(selectors.donationTaxReceiptInput)
      .filter(':disabled')
      .attr('data-disabled', true)
      .prop('disabled', false);

    $.ajax({
      url: window.RR.persistDonationsUrl,
      type: 'post',
      data: $form.serialize(),
      dataType: 'json',
    })

      .done((response) => window.location.assign(response.data.redirect))

      .fail((response) => {
        // Re-enable the prevent double submission
        $form.preventDoubleSubmission('reEnable');

        try {
          const { data } = response.responseJSON;
          const $alert = $form.find('.alert');

          $alert.addClass('hidden');
          $alert.empty();
          $form.find('.has-error').removeClass('has-error');

          data.errors.forEach((error, index) => {
            if (error.input !== null) {
              const $input = $form.find(`:input[name="${error.input}"]`);

              // Invisible inputs will have the error added to the form alerts
              if ($input.is(':visible')) {
                const $inputContainer = $input.closest('.form-group');
                $inputContainer.addClass('has-error');
                $inputContainer.find('p.js-error-help-block').remove();
                $inputContainer
                  .append(`<p class="js-error-help-block help-block">${error.message}</p>`);

                if (index === 0) {
                  $input.focus();
                }

                return;
              }
            }

            $alert.append(($alert.html().length !== 0 ? '<br>' : '') + error.message);
            $alert.removeClass('hidden');
          });
        } catch (e) {
          $snackBar.snackBar('add', {
            type: 'danger',
            icon: 'exclamation-circle',
            content: response.responseText,
          });
        }
      });

    // Add the disable state back to tax receipt inputs that should be disabled
    $form
      .find(selectors.donationTaxReceiptInput)
      .filter('[data-disabled]')
      .removeAttr('data-disabled')
      .prop('disabled', true);
  }

  /**
   * Initialize listeners and properties
   */
  function initialize() {
    if (!$form.length) {
      return;
    }

    fundraisingOrganizations = mapJSON(window.RR.fundraisingOrganizations);
    registrants = mapJSON(window.RR.fundraisingRegistrants);
    teams = mapJSON(window.RR.fundraisingTeams);
    subEvents = mapJSON(window.RR.donatableOrganizationsBySubEvent);
    ({ mandatoryDonationSettings } = window.RR);
    ({ globalMandatoryDonationSettings } = window.RR);

    $form.on('click', selectors.addDonation, addDonation);
    $form.on('click', selectors.applyDonation, applyDonation);
    $form.on('click', selectors.editDonation, editDonation);
    $form.on('click', selectors.removeDonation, removeDonation);
    $form.on('change', selectors.copyDonationInput, copyDonation);
    $form.on('change', selectors.donationAmountInput, selectAmount);
    $form.on('change', selectors.donationAmountInput, updateDonationAmountWithFees);
    $form.on('change blur', selectors.customDonationAmountInput, updateDonationAmountWithFees);
    $form.on('change', selectors.isFeeAppendedInput, updateDonationAmountWithFees);
    $form.on('change', selectors.donationAmountInput, updateDonationTotalDisplay);
    $form.on('change blur', selectors.customDonationAmountInput, updateDonationTotalDisplay);
    $form.on('change', selectors.donationAmountWithFees, updateDonationTotalDisplay);
    $form.on('click', selectors.removeDonation, updateDonationTotalDisplay);
    $form.on('blur', selectors.customDonationAmountInput, (event) => {
      const $this = $(event.currentTarget);
      const $donationContainer = $this.closest(selectors.donationContainer);
      $donationContainer.find(selectors.fundraisingOrganizationInput).trigger('change');
    });
    $form.on('change', selectors.fundraisingOrganizationInput, selectFundraisingOrganization);
    $form.on('change', selectors.fundraisingOrganizationInput, updateDonationAmountWithFees);
    $form.on('change', selectors.donationTypeInput, selectDonationType);
    $form.on('change', selectors.donorTypeInput, selectDonorType);
    $form.on('change', selectors.donationAmountInput, updateCollapsedContent);
    $form.on('change blur', selectors.customDonationAmountInput, updateCollapsedContent);
    $form.on('change blur', selectors.customDonationAmountInput, (event) => {
      const $donationContainer = $(event.currentTarget).closest(selectors.donationContainer);
      attemptToOptInForTaxReceipt($donationContainer.data('registrant-index'));
    });
    $form.on('change', selectors.donationAmountWithFees, updateCollapsedContent);
    $form.on('change', selectors.fundraisingOrganizationInput, updateCollapsedContent);
    $form.on('change', selectors.fundraisingOrganizationInput, toggleFundraisingOrganizationQuestions);
    $form.on('change blur', () => { checkIfMandatoryDonationRequirementsAreMet(); });
    $form.on('submit', persistDonations);

    // Initialize the existing forms
    $form.find(selectors.donationContainer).each((index, element) => initializeDonationContainer($(element)));
    $form.find(selectors.donationAmountInput).filter(':checked').trigger('change');
    $form.find(selectors.fundraisingOrganizationInput).trigger('change');
    $form.find(selectors.donorTypeInput).trigger('change');

    // If there is only one donation form, but no donations, we want to force the donation view to be shown
    possiblyExpandFormWhenOneRegistrant();

    checkIfMandatoryDonationRequirementsAreMet();

    $form.trigger('raceRoster.preventDoubleSubmission.reEnable');
  }

  initialize();
});
